export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt": {
        "minimum-allowed-size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["menores que 1MB"])},
        "we-recommend-file-of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recomendamos arquivos"])},
        "search-your-files": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["procure no seu computador"])},
        "drag-file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arraste seu arquivo aqui ou"])}
      }
    }
  })
}